import React from 'react';
import PropTypes from 'prop-types';

import './carouselHeader.less';
/**
 * Generic component for rendering the Title above the Carousel.
 * Optionally renders a tagline which appears on the same line as the headerText.
 * Children can be used to render elements below the headerText
 * @param {any} props
 */
const CarouselHeader = (props) => {

	const renderTagline = () => {
		return (
			<span className="tagline"> {props.headerTagline}</span>
		);
	}

	return (
		<div className="carousel-header">
			<h2>{props.headerText}{props.headerTagline && renderTagline()}</h2>
			<span>{props.children}</span>
		</div>
	);
};

CarouselHeader.propTypes = {
	headerText: PropTypes.string.isRequired,
	headerTagline: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
};

export default CarouselHeader;



// WEBPACK FOOTER //
// ./src/react/views/carousel/CarouselHeader.jsx